// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.TextInput_scroll__NNwmc::-webkit-scrollbar {
  height: 8px;
}
.TextInput_scroll__NNwmc::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.TextInput_scroll__NNwmc::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.TextInput_InputWrapper__3q3CS:focus-within label {
  color: var(--secondaryColor);
}
.TextInput_InputWrapper__3q3CS:focus-within label.TextInput_LabelError__CqgyQ {
  color: var(--errorColor);
}
.TextInput_InputWrapper__3q3CS label.TextInput_LabelError__CqgyQ {
  color: var(--errorColor);
}
.TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb {
    column-gap: 10px;
  }
}
.TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb label,
.TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb p {
  margin-bottom: 10px;
  font-size: 12px !important;
  line-height: 15px;
}
.TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb label {
  text-transform: capitalize;
}
.TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb p {
  color: var(--errorColor);
  font-size: 12px !important;
}
body[dir=ltr] .TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb p {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .TextInput_InputWrapper__3q3CS .TextInput_label_required__fDiZb p {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY {
  display: flex;
  align-items: center;
  position: relative;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea {
  height: 95px;
  min-height: 95px;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea {
  width: 100%;
  border: 1px solid var(--borderColor);
  background-color: var(--bgColor);
  padding: 10px;
  font-size: 10px;
  height: 32.5px;
  resize: none;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input.TextInput_addIcon__hsOHN,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea.TextInput_addIcon__hsOHN {
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input.TextInput_addIconWithBorder__TsmMr,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea.TextInput_addIconWithBorder__TsmMr {
  -webkit-padding-start: 40px;
          padding-inline-start: 40px;
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input:focus,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea:focus {
  border-color: var(--secondaryColor);
  outline: none;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input.TextInput_InputError__yt8Z1:focus,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea.TextInput_InputError__yt8Z1:focus {
  border-color: var(--errorColor);
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input.TextInput_InputDisabled__-42t5,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea.TextInput_InputDisabled__-42t5 {
  background-color: var(--borderColor);
  color: rgba(var(--mainColor), 0.5) !important;
  opacity: 0.7;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input::placeholder,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea::placeholder {
  font-size: 10px !important;
  text-transform: capitalize;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY input.TextInput_InputErrorWithoutFocus__7tJjO,
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY textarea.TextInput_InputErrorWithoutFocus__7tJjO {
  border-color: var(--errorColor);
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY i {
  position: absolute;
}
body[dir=ltr] .TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY i {
  left: 10px;
}
body[dir=rtl] .TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY i {
  right: 10px;
}
.TextInput_InputWrapper__3q3CS .TextInput_TextInput__LTWyY svg {
  width: 10px;
  height: 10px;
}
.TextInput_InputWrapper__3q3CS .TextInput_iconWithBorder__Mw10P {
  height: 60%;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 25px;
}
.TextInput_InputWrapper__3q3CS .TextInput_iconRightBorder__uEjoW {
  border-right: 1px solid var(--borderColor);
  padding-right: 5px;
}
.TextInput_InputWrapper__3q3CS .TextInput_iconLeftBorder__1vPhB {
  border-left: 1px solid var(--borderColor);
  padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Form/Inputs/TextInput/TextInput.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAlDE;EACE,4BAAA;AAqDJ;AApDI;EACE,wBAAA;AAsDN;AAlDI;EACE,wBAAA;AAoDN;AAjDE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAmDJ;ADsFE;EC7IA;IAOI,gBAAA;EAoDJ;AACF;AAlDI;;EAEE,mBAAA;EDkFF,0BAAA;EChFE,iBAAA;AAoDN;AAlDI;EACE,0BAAA;AAoDN;AAlDI;EACE,wBAAA;EACA,0BAAA;AAoDN;AAnDM;EACE,iEAAA;AAqDR;AAnDM;EACE,iEAAA;AAqDR;AAhDE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAkDJ;AAhDI;EACE,YAAA;EACA,gBAAA;AAkDN;AA/CI;;EAGE,WAAA;EACA,oCAAA;EACA,gCAAA;EACA,aAAA;EAEA,eAAA;EACA,cAAA;EACA,YAAA;AA+CN;AA7CM;;EACE,2BAAA;UAAA,0BAAA;EACA,yBAAA;UAAA,wBAAA;AAgDR;AA9CM;;EACE,2BAAA;UAAA,0BAAA;EACA,yBAAA;UAAA,wBAAA;AAiDR;AA/CM;;EACE,mCAAA;EACA,aAAA;AAkDR;AAhDM;;EACE,+BAAA;AAmDR;AAjDM;;EACE,oCAAA;EACA,6CAAA;EACA,YAAA;AAoDR;AAlDM;;EDmBF,0BAAA;ECjBI,0BAAA;AAqDR;AAnDM;;EACE,+BAAA;AAsDR;AAnDI;EACE,kBAAA;AAqDN;AApDM;EACE,UAAA;AAsDR;AApDM;EACE,WAAA;AAsDR;AAnDI;EACE,WAAA;EACA,YAAA;AAqDN;AAlDE;EACE,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAoDJ;AAlDE;EACE,0CAAA;EACA,kBAAA;AAoDJ;AAlDE;EACE,yCAAA;EACA,iBAAA;AAoDJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.InputWrapper {\n  &:focus-within label {\n    color: var(--secondaryColor);\n    &.LabelError {\n      color: var(--errorColor);\n    }\n  }\n  label {\n    &.LabelError {\n      color: var(--errorColor);\n    }\n  }\n  .label_required {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n\n    @include Sm {\n      column-gap: 10px;\n    }\n\n    label,\n    p {\n      margin-bottom: 10px;\n      @include fontSize(12);\n      line-height: 15px;\n    }\n    label {\n      text-transform: capitalize;\n    }\n    p {\n      color: var(--errorColor);\n      font-size: 12px !important;\n      #{$ltr} & {\n        font-family: $latoRegular !important;\n      }\n      #{$rtl} & {\n        font-family: $CairoRegular !important;\n      }\n    }\n  }\n\n  .TextInput {\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    textarea {\n      height: 95px;\n      min-height: 95px;\n    }\n\n    input,\n    textarea {\n      // min-height: 80px;\n      width: 100%;\n      border: 1px solid var(--borderColor);\n      background-color: var(--bgColor);\n      padding: 10px;\n      // transition: 0.3s;\n      font-size: 10px;\n      height: 32.5px;\n      resize: none;\n\n      &.addIcon {\n        padding-inline-start: 25px;\n        padding-inline-end: 10px;\n      }\n      &.addIconWithBorder {\n        padding-inline-start: 40px;\n        padding-inline-end: 10px;\n      }\n      &:focus {\n        border-color: var(--secondaryColor);\n        outline: none;\n      }\n      &.InputError:focus {\n        border-color: var(--errorColor);\n      }\n      &.InputDisabled {\n        background-color: var(--borderColor);\n        color: rgba(var(--mainColor), 0.5) !important;\n        opacity: 0.7;\n      }\n      &::placeholder {\n        @include fontSize(10);\n        text-transform: capitalize;\n      }\n      &.InputErrorWithoutFocus {\n        border-color: var(--errorColor);\n      }\n    }\n    i {\n      position: absolute;\n      #{$ltr} & {\n        left: 10px;\n      }\n      #{$rtl} & {\n        right: 10px;\n      }\n    }\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n  .iconWithBorder {\n    height: 60%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    width: 25px;\n  }\n  .iconRightBorder {\n    border-right: 1px solid var(--borderColor);\n    padding-right: 5px;\n  }\n  .iconLeftBorder {\n    border-left: 1px solid var(--borderColor);\n    padding-left: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `TextInput_scroll__NNwmc`,
	"InputWrapper": `TextInput_InputWrapper__3q3CS`,
	"LabelError": `TextInput_LabelError__CqgyQ`,
	"label_required": `TextInput_label_required__fDiZb`,
	"TextInput": `TextInput_TextInput__LTWyY`,
	"addIcon": `TextInput_addIcon__hsOHN`,
	"addIconWithBorder": `TextInput_addIconWithBorder__TsmMr`,
	"InputError": `TextInput_InputError__yt8Z1`,
	"InputDisabled": `TextInput_InputDisabled__-42t5`,
	"InputErrorWithoutFocus": `TextInput_InputErrorWithoutFocus__7tJjO`,
	"iconWithBorder": `TextInput_iconWithBorder__Mw10P`,
	"iconRightBorder": `TextInput_iconRightBorder__uEjoW`,
	"iconLeftBorder": `TextInput_iconLeftBorder__1vPhB`
};
export default ___CSS_LOADER_EXPORT___;
